import { toast } from "react-hot-toast";
import { useAtom, useSetAtom } from "jotai";

import authStorage from "./storage";
import apiClient from "../lib/apiClient";
import { currentUserAtom, socialMediaAtom } from "../config/state";
import userIcon from "@/assets/img/user.png";

export default function useAuth() {
  const [currentUser, setCurrentUser] = useAtom(currentUserAtom);
  const setSocialMedia = useSetAtom(socialMediaAtom);
  
  const logIn = (data) => {
    authStorage.storeToken(data.token);
    localStorage.setItem("rosta-tv", JSON.stringify(data.user));

    setCurrentUser(data.user);
    setSocialMedia(data.socialLinks);
  };

  const logOut = async () => {
    authStorage.removeToken();
    localStorage.removeItem("user");

    window.open("/auth/login", "_self");
  };

  const updateUser = async () => {
    if(! currentUser) return;
  
    const { data, ok } = await apiClient.get("/users/me");
    if(data?.state < 0 || !ok) {
      console.log("Err in updateUser in useAuth:", data);
      return toast.error("An error occured. Please try again later.");
    }

    localStorage.setItem("rosta-tv", JSON.stringify(data.user));

    setCurrentUser(data.user);
    setSocialMedia(data.socialLinks);
  }

  const getUserImage = (image = currentUser?.image) => {
    if(image) return `${import.meta.env.VITE_WEBSITE_URL}/uploads/user/${image}`;

    return userIcon;
  };

  return { logIn, logOut, setCurrentUser, currentUser, updateUser, getUserImage };
};